import React, { useState, useEffect } from "react";
import {
  concatStringFromClassesArrayList,
  sanitiseString,
} from "../../Utils/StringUtils";
import { Field } from "../Field";
import { Label } from "../Label";
import { Error } from "../Error";

export interface Props {
  id: string;
  label: React.ComponentProps<typeof Label>;
  options: {
    value: string | number;
    text: string;
    disabled?: boolean;
  }[];
  name?: string;
  classes?: string;
  variants?: "wide" | "inline";
  dataTestId: string;
  error?: React.ComponentProps<typeof Error>;
  onChange?: (selectedValue: string | number) => void;
}

export const Select = (props: Props) => {
  const [selectedValue, setSelectedValue] = useState<string | number>(
    props.options.length > 0 ? props.options[0].value : ""
  );

  const classList = {
    defaultClass: "ons-input ons-input--select",
    optionalClasses: [
      props.variants?.includes("wide") ? "ons-input--block" : null,
      props.variants?.includes("inline") ? "ons-u-wa--@xxs" : null,
      props.error ? "ons-input--error" : null,
      props.classes ? props.classes : null,
    ],
  };
  const className = concatStringFromClassesArrayList(classList);

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();
    const selectedValue = event.target.value;
    setSelectedValue(selectedValue);
    props.onChange && props.onChange(selectedValue);
  };

  // useEffect(() => {
  //   if (props.options.length > 0 && selectedValue !== props.options[0].value) {
  //     props.onChange && props.onChange(selectedValue);
  //   }
  // }, [selectedValue, props.onChange, props.options]);

  const renderSelect = () => {
    const sanitiseId = sanitiseString(props.id);
    const sanitiseDataTestId = sanitiseString(props.dataTestId);
    const labelId = props.label.id || `${sanitiseId}-label-id`;

    return (
      <Field
        inline={props.variants?.includes("inline")}
        dataTestId={sanitiseDataTestId}
        children={
          <React.Fragment>
            <Label
              id={labelId}
              text={props.label.text}
              for={sanitiseId}
              description={props.label.description}
            />
            <select
              id={sanitiseId}
              name={props.name}
              className={className}
              onChange={handleOnChange}
              value={selectedValue}
              data-testid={"select-" + sanitiseDataTestId}
              aria-labelledby={labelId}
            >
              {props.options.map((option, index) => (
                <option
                  key={index}
                  id={index.toString()}
                  disabled={option.disabled}
                  value={option.value}
                  data-testid={
                    "select-option-" +
                    sanitiseDataTestId +
                    "-" +
                    sanitiseString(option.text)
                  }
                >
                  {option.text}
                </option>
              ))}
            </select>
          </React.Fragment>
        }
      />
    );
  };

  return props.error ? (
    <Error
      text={props.error.text}
      children={renderSelect()}
      id={props.error.id}
      dataTestId={props.dataTestId + "-error"}
    />
  ) : (
    renderSelect()
  );
};
